// =====================================================
// BUDGET STATUS BADGE
// Badge visual de estado del presupuesto
// =====================================================
import type { BudgetStatus } from '../../types/budget';
import { BUDGET_STATUS_LABELS, BUDGET_STATUS_COLORS } from '../../types/budget';

interface BudgetStatusBadgeProps {
  status: BudgetStatus;
  size?: 'sm' | 'md';
}

export function BudgetStatusBadge({ status, size = 'md' }: BudgetStatusBadgeProps) {
  const colors = BUDGET_STATUS_COLORS[status];
  const label = BUDGET_STATUS_LABELS[status];

  const sizeClass = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-xs font-medium';

  return (
    <span className={`inline-flex items-center rounded-full border font-medium ${sizeClass} ${colors.bg} ${colors.text} ${colors.border}`}>
      {label}
    </span>
  );
}
